<template>
  <div class="sales-mes-details public-content">
    <!--标题-->
    <div class="breadcrumb" style="background: #fff">业务信息</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="basicInfo" label-width="100px">
        <el-form-item label="业务:">
          <el-input v-model="basicInfo.fullName"></el-input>
        </el-form-item>
        <el-form-item label="手机号:">
          <!--          <el-input v-model="basicInfo.phone"></el-input>--> {{ basicInfo.phone }} </el-form-item>
        <el-form-item label="地址:">
          <el-select v-model="selectAddress.sheng" value-key="code" @change="getAllshi" clearable v-if="$store.state.user.userType === 'SALESMAN'">
            <el-option v-for="(option, index) in address.sheng" :key="'provinces' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <el-select v-model="selectAddress.shi" value-key="id" @change="getAllQu" clearable v-if="$store.state.user.userType === 'SALESMAN'">
            <el-option v-for="(option, index) in address.shi" :key="'city' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <el-select v-model="selectAddress.qu" value-key="id" clearable v-if="$store.state.user.userType === 'SALESMAN'">
            <el-option v-for="(option, index) in address.qu" :key="'region' + index" :value="option" :label="option.name">
            </el-option>
          </el-select>
          <!--          <el-input v-model="basicInfo.address" style="min-width: 420px;"></el-input>-->
          <span v-if="$store.state.user.userType !== 'SALESMAN'"> {{ basicInfo.address.city === undefined ? '' : (basicInfo.address.city + basicInfo.address.county) }} </span>
        </el-form-item>
        <el-form-item label="详细地址:">
          <el-input v-model="basicInfo.address.fullAddress" v-if="$store.state.user.userType === 'SALESMAN'"></el-input>
          <span v-if="$store.state.user.userType !== 'SALESMAN'"> {{ basicInfo.address ? basicInfo.address.fullAddress : '' }} </span>
        </el-form-item>
        <el-form-item label="二维码:">
          <div class="upload-img">
            <input type="file" name="" id="input_img" @change="upload($event)" />
            <div class="recharge-ok">上传二维码</div>
          </div>
          <div id="show_img">
            <img :src="basicInfo.qrCode" alt="">
          </div>
          <p style="color: #999">支持格式：.jpg.png ，单个文件不能超过10MB，再次上传将替换</p>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button type="primary" @click="onSubmit" round>保存</el-button>
    </div>
  </div>
</template>
<script>
import imgSrc from '@/assets/images/money.svg'
import { getSalemanById, salesmanUpdate, addressGetAllProvince, addressGetCityByProvinceCode, addressGetCountyByCityId } from '@/api/crm'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
export default {
  name: 'sales-mes-details',
  data () {
    return {
      basicInfo: {
        salesman: '',
        orderNum: '',
        shouhuoren: '',
        phone: '',
        address: {
          fullAddress: ''
        },
        createDate: '',
        qrCode: ''
      },
      selectAddress: {
        sheng: {},
        shi: {},
        qu: {}
      },
      address: {
        sheng: {},
        shi: {},
        qu: {}
      }
    }
  },
  created () {
    this.getSaleMsg()
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    if (this.$store.state.user.userType === 'SALESMAN') { this.getAllSheng() }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    getAllQu () {
      if (this.selectAddress.shi === '') {
        this.selectAddress.qu = ''
        return
      }
      addressGetCountyByCityId(this.selectAddress.shi.id).then(res => {
        if (res.data.success) {
          this.address.qu = res.data.data
          if (res.data.data.filter(item => { return item.id === this.selectAddress.qu.id }).length === 0) {
            this.selectAddress.qu = res.data.data[0]
          }
        }
      })
    },
    getAllshi () {
      if (this.selectAddress.sheng === '') {
        this.selectAddress.shi = ''
        this.selectAddress.qu = ''
        return
      }
      addressGetCityByProvinceCode(this.selectAddress.sheng.code).then(res => {
        if (res.data.success) {
          this.address.shi = res.data.data
          if (res.data.data.filter(item => { return item.id === this.selectAddress.shi.id }).length === 0) {
            this.selectAddress.shi = res.data.data[0]
            this.selectAddress.qu = ''
            this.getAllQu()
          }
        }
      })
    },
    getAllSheng () {
      addressGetAllProvince().then(res => {
        if (res.data.success) {
          this.address.sheng = res.data.data
        }
      })
    },
    onSubmit () {
      let addressVo = {
        city: this.selectAddress.shi.name,
        cityId: this.selectAddress.shi.id,
        county: this.selectAddress.qu.name,
        countyId: this.selectAddress.qu.id,
        fullAddress: this.basicInfo.address.fullAddress,
        id: this.basicInfo.address.id ? this.basicInfo.address.id : '',
        province: this.selectAddress.sheng.name,
        provinceCode: this.selectAddress.sheng.code
      }
      let editSalesmanVo = {
        fullName: this.basicInfo.fullName,
        id: this.basicInfo.id,
        qrCode: this.basicInfo.qrCode,
        addressVo
      }
      salesmanUpdate(editSalesmanVo).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.$router.go(-1)
        }
      })
    },
    getSaleMsg () {
      getSalemanById(this.$route.query.id).then(res => {
        if (res.data.success) {
          let obj = res.data.data
          if (res.data.data.address) {
            this.selectAddress = {
              sheng: {
                code: res.data.data.address.provinceCode,
                name: res.data.data.address.province
              },
              shi: {
                id: res.data.data.address.cityId,
                name: res.data.data.address.city
              },
              qu: {
                id: res.data.data.address.countyId,
                name: res.data.data.address.county
              }
            }
            this.getAllshi()
            this.getAllQu()
          }
          if (obj.address === undefined) {
            obj.address = {
              fullAddress: ''
            }
          }
          this.basicInfo = res.data.data
        }
      })
    },
    upload (e) {
      var file = e.target.files
      let str = file[0].type.split('/')[1]
      if (file[0].size >= 10 * 1048576) {
        this.$message.warning('单个文件不能超过10MB')
        return
      }
      if (str !== 'png' && str !== 'jpeg') {
        this.$message.warning('只支持上传jpeg/png图片')
        return
      }
      uploadWebImg(file[0], this.$store.state.awsSdk.product.s3).then(res => {
        if (res) {
          this.basicInfo.qrCode = res
        } else {
          this.$message.error('图片插入失败')
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index.less";
@deep: ~">>>";
</style>
